var countryData = [{ code: "IR", value: "IR", name: "Iran", phoneCode: "+98" }];

if (window.countryData && window.countryData.length) {
  countryData = [...window.countryData];
}

export function toggleCountryCodeModal() {
  if (!$(this).hasClass("disabled")) {
    $(this)
      .closest(".js-country-code")
      .find(".js-country-code-body")
      .toggleClass("is-open");

    if (window.innerWidth < 993) {
      $("html").toggleClass("no-scroll");
    }
  }
}

$(".js-country-code-placeholder").val("IR");

if (countryData.length === 1) {
  $(".js-country-code-placeholder").addClass("disabled");
} else {
  countryData.forEach(function (item) {
    $(".js-country-code-list").append(
      "<li class='country-code__item js-country-code-item' data-value='" +
        item.value +
        "'" +
        "data-phone-code='" +
        item.phoneCode +
        "'>" +
        "<div><img src=/cdn/Booking.ir/UI/Assets/Img/flags/" +
        item.code +
        ".svg>" +
        "<label>" +
        item.name +
        "</label>" +
        "</div>" +
        "<label>(" +
        item.phoneCode +
        ")</label>" +
        "</li>"
    );
  });

  $(".js-country-code-placeholder").on("click", toggleCountryCodeModal);
  $(".js-close-country-code").on("click", toggleCountryCodeModal);

  $(".js-country-code-item").on("click", function () {
    $(".js-country-code")
      .find(".js-country-code-placeholder img")
      .attr("src", $(this).find("div img").attr("src"));
    $(".js-country-code")
      .find(".js-country-code-placeholder label")
      .text($(this).find("div label").attr("src"));
    $(".js-country-code")
      .find(".js-country-code-placeholder label")
      .text($(this).attr("data-phone-code"));
    $(".js-country-code")
      .find(".js-country-code-placeholder")
      .val($(this).attr("data-value"));

    toggleCountryCodeModal.call(this);
  });

  // close country body
  $("body").on("click", function (event) {
    if (
      !$(event.target).closest(".js-country-code").length &&
      $(event.target).find(".js-country-code-body.is-open")
    ) {
      $("body").find(".js-country-code-body.is-open").removeClass("is-open");

      if (window.innerWidth < 993) {
        $("html").removeClass("no-scroll");
      }
    }
  });
}
